import { render, staticRenderFns } from "./ModalAlert.vue?vue&type=template&id=ba4eddfa&scoped=true"
import script from "./ModalAlert.vue?vue&type=script&lang=js"
export * from "./ModalAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba4eddfa",
  null
  
)

export default component.exports